import React, { useEffect, useState } from "react";
import backicon from "../../../../../../Assets/icons/backIcon.svg";
import { useLocation, useNavigate } from "react-router-dom";
import axiosInstance from "../../../../../services/api/API";
import editIcon from "../../../../../../Assets/icons/Un-Checkbox.svg";
import updateIcon from "../../../../../../Assets/icons/check-circle (8) 1.svg";
import DetailsTable from "../AllotQuantity/DetailsTable";
import ListLogisticsFilters from "../../../LogisticsFilter";
import { all } from "axios";
// import { IoCheckmarkSharp } from "react-icons/io5";
// import PhysicalStockin from '../PhysicalStock-in';

const StockHistory = ({allotData,isSubmit,isHistoryTable,isSerailDrawerOpen}) => {
  const [poApprovalEdit, setPoApprovalEdit] = useState([]);
  const [poId, setPoId] = useState(0);
  const [formData, setFormData] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [ filterFormData, setFilterFormData ] = useState({});
  const [quantities, setQuantities] = useState({});
  const [validationErrors, setValidationErrors] = useState({});
 // const location = useLocation();

  const [editRowId, setEditRowId] = useState(null); // Track the row being edited
  const [editedQuantity, setEditedQuantity] = useState({}); // Track edited quantity for the specific row

  const [editRow, setEditRow] = useState(null);
  //   const []

  const [businessPartnerIdState, setBusinessPartnerIdState] = useState(null);
  // const [PhysicalStockinId,setPhysicalStockinId] = useState(0)
  const [productdetails, setProductDetails] = useState([]);
  const token = localStorage.getItem("authToken");
 
const navigate = useNavigate()
  const location = useLocation();
  const data  = location.state || {};
  console.log("location>>",location);
  
  const POID = allotData?.POID || allotData?.poID;
  console.log("locationdata<><><>", POID);

//   useEffect(() => {
//     fetchPoApprovalDetailsEdit();
//   }, []);

//   const fetchPoApprovalDetailsEdit = async () => {
//     try {
//       const response = await axiosInstance.get(
//         `/purchaseorder/edit/${data.po_id}`,
//         {
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${token}`,
//           },
//         }
//       );
//       const fetchedData = response.data.data;

//       console.log(fetchedData, "FETCHEDDATA");
//       setPoApprovalEdit(fetchedData);
//       const poIdVal = response.data.data.po_id;
//       console.log(poIdVal, "POVALID");
//       setPoId(poIdVal);

//       console.log(formData, "depatartment DATA");
//     } catch (error) {
//       console.log(error);
//     }
//   };

  useEffect(() => {
    if(isSerailDrawerOpen)
      fetchProductDetails();
    },[isSerailDrawerOpen]);
    const handleSearch=()=>{
       
    //console.log(filterFormData,'filterFormData/////////////////')
    fetchProductDetails();
        
    }

  const fetchProductDetails = async (page = 0, pageSize = 5) => {
    try {
      const response = await axiosInstance.post(
        "/postockoutdetail/allotitemlist",
        {
    is_selected:1,
    variant_id:allotData?.variant_id,
    itemtype:allotData?.itemtype,
    po_details_id:allotData?.po_details_id,
    item_id:allotData?.item_id,
    vendor_id:allotData?.vendor_onboard_id,
    orderBy:"phystockinsr_id desc",
    page,
    pageSize,
    searchText:null
        },
      
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const formattedData = response?.data?.data?.data;

      console.log(formattedData, "formattedData");
      setProductDetails(formattedData);

      const quantities = formattedData.map((item) => item.po_details_id);
      console.log(quantities, "QuantValues");

      const totalRecordsData = response?.data?.data?.totalRecords;
      setTotalRecords(totalRecordsData);

      setTotalPages(Math.ceil(response?.data?.data?.totalRecords / pageSize));
    } catch (error) {
      console.error("Error fetching department list:", error);
    }
  };

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    fetchProductDetails(newPage);
  };
  const getTableHeadersAndMappings = () => {
    let headers = ["Serial No."]; // Always show "Serial No."
    let keyMapping = { "Serial No.": "serial_no" };

    if (allotData?.itemtype !== "S" && allotData?.itemtype !== "A") {
      headers = ["Chassis No.", "Engine no.", ...headers];
      keyMapping = {
        "Chassis No.": "chassis_no",
        "Engine no.": "engine_no",
        ...keyMapping
      };
    }

    keyMapping["Action"] = [
      {
        type: "edit",
        label: "Edit",
        icon: editIcon
      }
    ];

    return { headers, keyMapping };
  };

  const { headers: DEPARTMENT_TABLE_HEADERS, keyMapping: DEPARTMENT_KEY_MAPPING } = getTableHeadersAndMappings();


//   const DEPARTMENT_TABLE_HEADERS = [
//     // "Sr No.",
//     // "Department ID",
//     "Chassis No.",
    
//     "Engine no.",
//     "Serial No.",
  
//   ];

//   const DEPARTMENT_KEY_MAPPING = {
//     "Chassis No.":"chassis_no",
    
//     "Engine no.":"engine_no",
//     "Serial No.":"serial_no",
   
  
//    'Action': [
//       {
//         type: 'edit',
//         label: 'Edit',
//         icon: editIcon,
//       },
      
     
//     ]
//   };
  const filtersInputs = [
  
    {
      name: "search",
      label: "Search",
      type: "text",
      placeholder:"Search..",
      required: false,
      gridClass: "col-lg-4",
  },
   
   
  ]
 
  const handleEditClick = (row) => {
    console.log(row.po_details_id, "row");
   setEditRow(row.po_details_id)
    setEditRowId(row.item_id); // Set the specific row in edit mode
    setEditedQuantity({ [row.po_details_id]: row.qty_approved }); // Initialize with the current quantity for the specific row
  };
 

  const handleSave = async (row) => {
    
    console.log(
      "Saving Quantity for row:",
      row.editRowId,
      "New Quantity:",
      editedQuantity[row.editRowId]
    );

    const rowToUpdate = productdetails.find(
      (item) => item.editRowId === row.editRowId
    );

    if (rowToUpdate) {
      const newQuantity = editedQuantity[row.editRowId];

      const total = newQuantity * rowToUpdate.rate;
      const taxAmountValue = total * rowToUpdate.tax;
      const newTaxAmount = taxAmountValue;
      const newTotalPrice = newTaxAmount + total;

      // Prepare payload for saving
      const payload = {
        qty_approved: newQuantity,
        totalprice: String(newTotalPrice),
        taxset_amount: String(newTaxAmount),
      };

      try {
        const response = await axiosInstance.patch(
          `/purchaseorderapproval/update/${row.po_details_id}`,
          payload,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );
        console.log(response, "EDITQUANTRESPONSE");

        setProductDetails((prevDetails) =>
          prevDetails.map((item) =>
            item.po_details_id === row.po_details_id
              ? {
                  ...item,
                  qty_approved: newQuantity,
                  totalprice: newTotalPrice,
                  taxset_amount: newTaxAmount,
                }
              : item
          )
        );
      } catch (error) {
        console.log(error);
      }

      // After saving, reset the edit state
      setEditRowId(null);
    }
  };
  

  const handleClear =  () => {
  
    setFilterFormData({})
    //setFilters({});

  
    
  };

  return (
    <div>
      <div className="">
        <div
          style={{
            paddingBottom: "35px",
            borderBottom: "1px solid lightgray",
            padding: "35px",
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div>
            
            <div className="backbutton" onClick={()=>navigate(-1)}>
              <img src={backicon} alt="back" />
              <span className="backbtntitleDetails"> Stock Out Alloted History</span>
            </div>
          </div>
         
        </div>

        <div>
          <div className="">
           
          

            <div style={{ paddingTop: "14px" }}>
              <DetailsTable
                data={productdetails}
                headers={DEPARTMENT_TABLE_HEADERS}
                keyMapping={DEPARTMENT_KEY_MAPPING}
                itemsPerPage={10}
                onPageChange={handlePageChange}
                handleEditClick={handleEditClick}
               // handleQuantityChange={handleQuantityChange}
                handleSave={handleSave}
                editRowId={editRowId}
                setEditRowId={setEditRowId}
                quantities={quantities}
                allotData={allotData}
                setQuantities={setQuantities}
                editedQuantity={editedQuantity}
                setEditedQuantity={setEditedQuantity}
                updateIcon={updateIcon}
                POID={POID}
                isSubmit={isSubmit}
                isHistoryTable={isHistoryTable}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StockHistory;
